<template>
<v-dialog v-model="dialogCreateTaskCalendar" persistent max-width="720" class="CSChatThai">
  <v-card>
    <v-card tile flat>
      <v-toolbar card class="toolbar-card-v2">
        <v-toolbar-title class="CSChatThai">
          {{$t('Task.create.header')}}
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn dark icon flat @click="closeDialog">
          <v-icon style="color: black !important; font-size: 20px !important;">clear</v-icon>
        </v-btn>
      </v-toolbar>
      <v-system-bar class="system-bar">  </v-system-bar>
    </v-card>
    <v-card-text  class="CSChatThai scrolling-wrapper" style="height: 80vh;">
        <v-stepper v-model="e1">
          <v-stepper-header>
            <template>
              <v-stepper-step
                key="1-step"
                step="1"
                :complete="e1 > 1"
              >
                {{$t('Task.allTask.selectProject')}}
              </v-stepper-step>
              <v-divider></v-divider>
              <v-stepper-step
                key="2-step"
                step="2"
                :complete="e1 > 2"
              >
                {{$t('Task.allTask.createProject')}}
              </v-stepper-step>
            </template>
          </v-stepper-header>
          <v-stepper-items>
            <v-stepper-content step="1" key="1-content">
              <v-card color="white" height="500px" v-if="progress">
                <v-layout row wrap align-center justify-center style="height: 500px">
                  <v-progress-circular size="80" color="primary" :indeterminate="progress"></v-progress-circular>
                </v-layout>
              </v-card>
              <v-card color="white" height="500px" v-else>
                <v-tabs icons-and-text left dark color="white" v-model="tabs">
                  <v-tabs-slider color="#232b35"></v-tabs-slider>
                  <v-tab :key="1" href='#tab-1'>
                    <span style="color: #232b35; text-transform: none;">{{$t('LeftSide.friend.friend')}}</span>
                    <v-icon color="#232b35">fas fa-user</v-icon>
                  </v-tab>

                  <v-tab :key="2" href='#tab-2'>
                    <span style="color: #232b35; text-transform: none;">{{$t('LeftSide.friend.group')}}</span>
                    <v-icon color="#232b35">fas fa-users</v-icon>
                  </v-tab>
                  <v-tab-item id="tab-1">
                    <v-card flat style="height: 400px;" class="scrolling-wrapper">
                      <v-list two-line>
                        <template v-for="(item, index) in FilterListProject">
                          <v-list-tile
                            :key="item._id"
                            avatar
                            ripple
                          >
                            <v-list-tile-avatar>
                              <img :src="item.path_pic" v-if="item.path_pic" class="alligator-turtle">
                              <img src="/static/img/default_profile/man-white.png" v-else class="alligator-turtle">
                            </v-list-tile-avatar>
                            <v-list-tile-content>
                              <v-list-tile-title>{{ item.project_name }}</v-list-tile-title>
                            </v-list-tile-content>
                            <v-list-tile-action>
                              <v-radio-group v-model="radios" :mandatory="false" @click="getstate(item)">
                                <v-radio :value="item"></v-radio>
                              </v-radio-group>
                            </v-list-tile-action>
                          </v-list-tile>
                          <v-divider v-if="index + 1 < listprojectfriend.length" :key="index"></v-divider>
                        </template>
                      </v-list>
                    </v-card>
                  </v-tab-item>

                  <v-tab-item id="tab-2">
                    <v-card flat style="height: 400px;" class="scrolling-wrapper">
                      <v-list two-line>
                        <template v-for="(item, index) in FilterListProjectGroup">
                          <v-list-tile
                            :key="item._id"
                            avatar
                            ripple
                          >
                            <v-list-tile-avatar>
                              <img :src="item.path_pic" v-if="item.path_pic" class="alligator-turtle">
                              <img src="/static/img/default_profile/group-white.png" v-else class="alligator-turtle">
                            </v-list-tile-avatar>
                            <v-list-tile-content>
                              <v-list-tile-title>{{ item.project_name }}</v-list-tile-title>
                            </v-list-tile-content>
                            <v-list-tile-action>
                              <v-radio-group v-model="radios" :mandatory="false" @click="getstate(item)">
                                <v-radio :value="item"></v-radio>
                              </v-radio-group>
                            </v-list-tile-action>
                          </v-list-tile>
                          <v-divider v-if="index + 1 < listprojectgroup.length" :key="index"></v-divider>
                        </template>
                      </v-list>
                    </v-card>
                  </v-tab-item>
                  <v-layout row wrap align-center justify-end class="ml-3 mr-4 bg-white" v-if="tabs == 'tab-1'">
                    <v-flex sm12 md12 lg12 xl12 class="ml-3 mt-3" v-if="listprojectfriend.length != 0">
                      <!-- <v-text-field
                        v-model="search"
                        solo
                        :label="$t('Task.allTask.placeholderSearchProject')"
                        clearable
                        append-icon="search"
                      ></v-text-field> -->
                      <input type="text" :placeholder="$t('Task.allTask.placeholderSearchProject')" class="CSChatThai inputtaskweb-search" v-model="search">
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap align-center justify-end class="ml-3 mr-4 bg-white" v-else>
                    <v-flex sm12 md12 lg12 xl12 class="ml-3 mt-3" v-if="listprojectgroup.length != 0">
                      <!-- <v-text-field
                        v-model="search_group"
                        solo
                        :label="$t('Task.allTask.placeholderSearchProject')"
                        clearable
                        append-icon="search"
                      ></v-text-field> -->
                      <input type="text" :placeholder="$t('Task.allTask.placeholderSearchProject')" class="CSChatThai inputtaskweb-search" v-model="search_group">
                    </v-flex>
                  </v-layout>
                </v-tabs>
              </v-card>
              <v-btn class="btncreate" @click="nextStep(1)" :disabled="projectid == ''">{{$t('Task.allTask.next')}}</v-btn>
              <!-- <v-btn class="btncancle" @click="">{{$t('AnswerQuestion.cancel')}}</v-btn> -->
            </v-stepper-content>
            <v-stepper-content step="2" key="2-content">
              <v-card color="white" style="height: 500px;" class="scrolling-wrapper">
                <v-layout row wrap>
                  <v-flex sm3 md3 xl3 lg3 class="textSubject">
                    <span>{{$t('Task.create.subject')}}<span style="color: red;">*</span> :</span>
                  </v-flex>
                  <v-flex sm9 md9 xl9 lg9 style="margin-top: 10px;">
                    <input type="text" :placeholder="$t('Task.create.placeholderSubject')" class="CSChatThai inputtaskweb" v-model="subject_task">
                  </v-flex>
                  <v-flex sm3 md3 xl3 lg3 class="textSubject">
                    <span>{{$t('Task.create.priority')}} :</span>
                  </v-flex>
                  <v-flex sm8 md8 xl8 lg8 style="margin-top:20px;">
                      <v-btn flat :class="(priority=='1')? 'selectedPriority': ''" style="text-transform: none;" @click="priority = '1';">
                        <v-icon class="btn-pri1">mdi-checkbox-blank</v-icon>&nbsp;&nbsp;&nbsp;&nbsp;{{$t('Task.create.p1')}}
                      </v-btn>
                      <v-btn flat :class="(priority=='2')? 'selectedPriority': ''" style="text-transform: none;" @click="priority = '2';">
                        <v-icon class="btn-pri2">mdi-checkbox-blank</v-icon>&nbsp;&nbsp;&nbsp;&nbsp;{{$t('Task.create.p2')}}
                      </v-btn>
                      <v-btn flat :class="(priority=='3')? 'selectedPriority': ''" style="text-transform: none;" @click="priority = '3';">
                        <v-icon class="btn-pri3">mdi-checkbox-blank</v-icon>&nbsp;&nbsp;&nbsp;&nbsp;{{$t('Task.create.p3')}}
                      </v-btn>
                  </v-flex>
                  <v-flex sm3 md3 xl3 lg3 class="textSubject">
                    <span>{{$t('Task.create.startDate')}}<span style="color: red;">*</span> :</span>
                  </v-flex>
                  <v-flex sm9 md9 xl9 lg9>
                    <v-menu
                        ref="menu1"
                        :close-on-content-click="false"
                        v-model="menu1"
                        :nudge-right="40"
                        :return-value.sync="start_date"
                        lazy
                        transition="scale-transition"
                        offset-y
                        full-width
                        style="width: 25%;"
                      >
                      <v-text-field
                        slot="activator"
                        v-model="start_date"
                        label=""
                        readonly
                      ></v-text-field>
                      <v-date-picker
                        v-model="start_date"
                        no-title scrollable
                        :allowed-dates="allowedDates"
                        :locale="$t('Task.allTask.localepicker')"
                        >
                        <v-spacer></v-spacer>
                        <v-btn flat color="primary" @click="menu1 = false" style="text-transform: none;">
                          {{$t('AnswerQuestion.cancel')}}
                        </v-btn>
                        <v-btn flat color="primary" @click="$refs.menu1.save(start_date)" style="text-transform: none;">
                          {{$t('AnswerQuestion.ok')}}
                        </v-btn>
                      </v-date-picker>
                    </v-menu>
                  </v-flex>
                  <v-flex sm3 md3 xl3 lg3 class="textSubject">
                    <span>{{$t('Task.create.endDate')}}<span style="color: red;">*</span> :</span>
                  </v-flex>
                  <v-flex sm9 md9 xl9 lg9>
                    <v-menu
                        ref="menu2"
                        :close-on-content-click="false"
                        v-model="menu2"
                        :nudge-right="40"
                        :return-value.sync="end_date"
                        lazy
                        transition="scale-transition"
                        offset-y
                        full-width
                        style="width: 25%;"
                      >
                      <v-text-field
                        slot="activator"
                        v-model="end_date"
                        label=""
                        readonly
                      ></v-text-field>
                      <v-date-picker
                        v-model="end_date"
                        no-title
                        scrollable
                        :allowed-dates="allowedDatesEnd"
                        :min="min_date_end"
                        :locale="$t('Task.allTask.localepicker')"
                        >
                        <v-spacer></v-spacer>
                        <v-btn flat color="primary" @click="menu2 = false" style="text-transform: none;">
                          {{$t('AnswerQuestion.cancel')}}
                        </v-btn>
                        <v-btn flat color="primary" @click="$refs.menu2.save(end_date)" style="text-transform: none;">
                          {{$t('AnswerQuestion.ok')}}
                        </v-btn>
                      </v-date-picker>
                    </v-menu>
                  </v-flex>
                  <v-flex sm3 md3 xl3 lg3 class="textSubject">
                    <span>{{$t('Task.create.description')}} :</span>
                  </v-flex>
                  <v-flex sm9 md9 xl9 lg9 style="margin-top: 20px;">
                    <v-textarea
                      :label="$t('Task.create.placeholderDescription')"
                      solo
                      no-resize
                      style="width: 75%;"
                      outline
                      height="80"
                      rows=3
                      hide-details
                      v-model="detail_task"
                    ></v-textarea>
                  </v-flex>
                  <v-flex sm3 md3 xl3 lg3 class="textSubject">
                    <span>{{$t('Task.create.assign')}} :</span>
                  </v-flex>
                  <v-flex sm9 md9 xl9 lg9>
                    <v-autocomplete
                      :items="member"
                      v-model="selectemember"
                      :label="$t('Task.create.placeholderAssign')"
                      item-text="name"
                      item-value="tokenuser"
                      multiple
                      chips
                      max-height="auto"
                      style=" width: 75%;"
                    >
                      <template slot="selection" slot-scope="data">
                        <v-chip
                          :selected="data.selectemember"
                          :key="JSON.stringify(data.item)"
                          close
                          class="chip--select-multi"
                          @input="data.parent.selectItem(data.item)"
                          v-if="data.item.type !== 'bot'"
                        >
                          <v-avatar>
                            <img v-if="data.item.profilepicture" :src="data.item.profilepicture" class="object-fit-img">
                            <img v-else-if="data.item.type === 'company'" src='/static/img/default_profile/business-white.png' class="object-fit-img">
                            <img v-else-if="data.item.type === 'government'" src='/static/img/default_profile/business-white.png' class="object-fit-img">
                            <img v-else-if="data.item.type === 'bot'" src='/static/img/default_profile/bot-white.png' class="object-fit-img">
                            <img v-else src='/static/img/default_profile/man-white.png' class="object-fit-img">
                          </v-avatar>
                          <p class="text-overflow-chip">{{ data.item.name }}</p>
                        </v-chip>
                      </template>
                      <template slot="item" slot-scope="data">
                        <template v-if="typeof data.item !== 'object'">
                          <v-list-tile-content v-text="data.item"></v-list-tile-content>
                        </template>
                        <template v-else>
                          <v-list-tile-avatar v-if="data.item.type !== 'bot'">
                            <img v-if="data.item.profilepicture" :src="data.item.profilepicture" class="object-fit-img">
                            <img v-else-if="data.item.type === 'company'" src='/static/img/default_profile/business-white.png' class="object-fit-img">
                            <img v-else-if="data.item.type === 'government'" src='/static/img/default_profile/business-white.png' class="object-fit-img">
                            <img v-else-if="data.item.type === 'bot'" src='/static/img/default_profile/bot-white.png' class="object-fit-img">
                            <img v-else src='/static/img/default_profile/man-white.png' class="object-fit-img">
                          </v-list-tile-avatar>
                          <v-list-tile-content>
                            <v-list-tile-title v-if="data.item.type !== 'bot'" class="text-overflow">{{data.item.name}}</v-list-tile-title>
                          </v-list-tile-content>
                        </template>
                      </template>
                    </v-autocomplete>
                  </v-flex>
                  <v-flex sm3 md3 xl3 lg3 class="textSubject">
                    <span>{{$t('Task.create.status')}} :</span>
                  </v-flex>
                  <v-flex sm9 md9 xl9 lg9 style="margin-top:20px;">
                    <v-select
                    :items="state"
                    v-model="state_id"
                    outlined
                    hide-details
                    item-text="name"
                    item-value="state_id"
                    style="padding:0; width: 25%;"
                  ></v-select>
                  </v-flex>
                  <v-flex sm3 md3 xl3 lg3 class="textSubject">
                    <span>{{$t('Task.create.checklist')}} :</span>
                  </v-flex>
                  <v-flex sm9 md9 xl9 lg9 style="margin-top:20px;">
                    <!-- <input type="text" :placeholder="$t('Task.create.placeholderChecklist')" class="CSChatThai inputtaskweb" v-model="subject_checklist"> -->
                    <v-layout row wrap align-start justify-start class="mr-1">
                      <input type="text" :placeholder="$t('Task.create.placeholderChecklist')" class="CSChatThai inputchecklistweb" v-model="subject_checklist">
                    </v-layout>
                    <v-layout row wrap align-end justify-end class="mr-2">
                      <v-btn class="btncreate" @click="add_checklist()" :disabled="subject_checklist == ''">{{$t('AnswerQuestion.keep')}}</v-btn>
                    </v-layout>
                    <v-layout row wrap justify-center v-for="(item, index) in check_list" class="mt-2 border-checklist" v-if="check_list.length != 0">
                      <div class="item">
                        <input  @change="onModifyClick($event, index)" type="checkbox"  :checked="item.check" v-if="item.check == 'true'">
                        <input  @change="onModifyClick($event, index)" type="checkbox"  v-else>
                        <p v-if="item.check == 'true'">{{item.label}}</p>
                        <p v-else>{{item.label}}</p>
                        <v-btn color="grey" flat icon small slot="activator" @click="delete_checklist(index)">
                          <v-icon class="font-size15">fas fa-trash-alt</v-icon>
                        </v-btn>
                      </div>
                    </v-layout>
                  </v-flex>
                </v-layout>
                <v-layout row wrap align-end justify-end class="mr-5" style="margin-top: 15px;">
                  <v-btn class="btncancle" @click="cancel_task()">{{$t('AnswerQuestion.cancel')}}</v-btn>
                  <v-btn class="btncreate" @click="add_task()" :loading="isloading"
                  :disabled="subject_task == '' || priority == undefined || start_date == '' || end_date == ''">{{$t('AnswerQuestion.ok')}}</v-btn>
                </v-layout>
              </v-card>
              <v-btn class="btncreate" @click="nextStep(2)">{{$t('Task.allTask.back')}}</v-btn>
              <!-- <v-btn class="btncancle">{{$t('AnswerQuestion.cancel')}}</v-btn> -->
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
    </v-card-text>
  </v-card>
</v-dialog>
</template>
<script>
import { sync } from 'vuex-pathify'
import { Decode } from '@/services'
// import DateRangePicker from 'vue2-daterange-picker'
// import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
var _ = require('lodash')
export default {
  props: {
    dialogCreateTaskCalendar: false
  },
  data: () => ({
    search_group: '',
    search: '',
    radios: null,
    e1: 1,
    steps: 2,
    detail_task: '',
    token: '',
    subject_task: '',
    menu1: false,
    menu2: false,
    start_date: new Date().toISOString().substr(0, 10),
    end_date: new Date().toISOString().substr(0, 10),
    min_date: '',
    max_date: '',
    priority: '1',
    member: [],
    state: [],
    state_id: '',
    selectemember: [],
    subject_taskRules: [
      v => !!v || 'กรุณากรอกหัวข้อการ์ดงาน',
    ],
    isloading: false,
    min_date_end: '',
    max_date_end: '',
    subject_checklist: '',
    listprojectfriend: [],
    listprojectgroup: [],
    tokenroom: '',
    projectid: '',
    tabs: 'tab-1',
    progress: false,
    check_list: [],
    check_list_select: []
    // dateFormatted: vm.formatDate(new Date().toISOString().substr(0, 10))
  }),
  components: {
    // DateRangePicker
  },
  created () {
    var decoded =  JSON.parse(Decode.decode(localStorage.getItem('Authenrization')))
    this.token = decoded['tokenuser']

  },
  mounted () {
  },
  computed: {
    ...sync('*'),
    FilterListProject () {
      if (this.search !== '' && this.search !== null) {
        return this.listprojectfriend.filter(post => {
          return post.project_name.toLowerCase().includes(this.search.toLowerCase())
        })
      } else {
        return this.listprojectfriend
      }
    },
    FilterListProjectGroup () {
      if (this.search_group !== '' && this.search_group !== null) {
        return this.listprojectgroup.filter(post => {
          return post.project_name.toLowerCase().includes(this.search_group.toLowerCase())
        })
      } else {
        return this.listprojectgroup
      }
    }
  },
  watch: {
    dialogCreateTaskCalendar () {
      // console.log(this.projectid)
      if (this.dialogCreateTaskCalendar) {
        this.start_date = localStorage.getItem('datestart')
        this.end_date = localStorage.getItem('datestart')
        this.get_list_project()
      }
    },
    steps (val) {
      if (this.e1 > val) {
        this.e1 = val
      }
    }
  },
  methods: {
    delete_checklist (index) {
      this.$swal({
        text: this.$t('Alert.Task.removeChecklist'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#2562af',
        cancelButtonColor: '#9f9f9f',
        confirmButtonText: this.$t('AnswerQuestion.ok'),
        cancelButtonText: this.$t('AnswerQuestion.cancel'),
        confirmButtonClass: 'btn btn-danger',
        cancelButtonClass: 'btn btn-success',
        buttonsStyling: true,
        showCloseButton: true,
        reverseButtons: true
      }).then((result) => {
        if (result.value) {
          this.check_list = []
          this.check_list_select = []
          this.check_list = JSON.parse(localStorage.getItem('check_list'))
          this.check_list.splice(index, 1)
          localStorage.setItem('check_list', JSON.stringify(this.check_list))
        }
      })
    },
    add_checklist () {
      this.check_list.unshift({
        'check': 'false',
        'label': this.subject_checklist
      })
      this.subject_checklist = ''
      this.check_list_select = this.check_list
      localStorage.setItem('check_list', JSON.stringify(this.check_list_select))
    },
    onModifyClick ({type, target}, index) {
      const event = {
          type,
          isCheckbox: target.type === 'checkbox',
          target: {
            value: target.value,
            checked: target.checked
          }
      }
      this.check_list[index].check = event.target.checked.toString()
      // this.check_list_select = this.check_list
      // console.log(this.check_list)
    },
    get_list_project () {
      this.progress = true
      this.axios.post(process.env.APIpub + '/v1/user/get_project_by_tokenuser', {
        tokenuser: this.token
      }).then((response) => {
        if (response.data.status == 'success') {
          this.progress = false
          this.listprojectgroup = _.filter(response.data.data, function(o) { return o.tokenroom.startsWith('G') })
          this.listprojectfriend = _.filter(response.data.data, function(o) { return o.tokenroom.startsWith('R') })
        }
      }).catch(error => {
        console.log(error.message)
      })
    },
    onInput (val) {
      this.steps = parseInt(val)
    },
    nextStep (n) {
      if (n === this.steps) {
        this.e1 = 1
        this.start_date = localStorage.getItem('datestart')
        this.end_date = localStorage.getItem('datestart')
        this.tabs = 'tab-1'
        // this.radios = null
        // this.projectid = ''
        this.selectemember = []
        this.priority = '1'
        this.detail_task = ''
        this.subject_task = ''
        this.subject_checklist = ''
        this.check_list = []
        this.check_list_select = []
      } else {
        this.e1 = n + 1
      }
    },
    allowedDates (val) {
      this.min_date_end = this.start_date
      if (this.start_date > this.end_date) {
        this.end_date = this.start_date
      }
      return this.min_date_end
    },
    allowedDatesEnd (val) {
      this.min_date_end = this.start_date
      if (this.min_date_end > this.end_date) {
        this.end_date = this.min_date_end
      }
      return this.end_date
    },
    closeDialog () {
      this.check_list = []
      this.check_list_select = []
      this.e1 = 1
      this.tabs = 'tab-1'
      this.radios = null
      this.projectid = ''
      this.selectemember = []
      this.priority = '1'
      this.detail_task = ''
      this.subject_task = ''
      this.subject_checklist = ''
      this.start_date = new Date().toISOString().substr(0, 10),
      this.end_date = new Date().toISOString().substr(0, 10),
      this.$emit('closeCreateTask', false)
    },
    getstate (item) {
      this.tokenroom = item.tokenroom
      this.projectid = item.project_id
      // console.log(item)
      this.axios.post(process.env.APIpub + '/v1/user/get_state_by_project', {
        tokenuser: this.token,
        tokenroom: this.tokenroom,
        project_id: this.projectid
      }).then((response) => {
        this.state = response.data.data.state
        this.state_id = response.data.data.state[0].state_id
        this.getroom()
      }).catch(error => {
        console.log(error.message)
      })
    },
    cancel_task () {
      this.radios = null
      this.selectemember = []
      this.priority = '1'
      this.detail_task = ''
      this.subject_task = ''
      this.subject_checklist = ''
      this.start_date = new Date().toISOString().substr(0, 10),
      this.end_date = new Date().toISOString().substr(0, 10)
      this.projectid = ''
    },
    add_task () {
      this.isloading = true
      this.axios.post(process.env.APIpub + '/v1/user/create_task', {
        tokenuser: this.token,
        tokenroom: this.tokenroom,
      	title: this.subject_task,
      	detail: this.detail_task,
      	state_id: this.state_id,
      	time_start: this.start_date + ' 00:00:00',
      	time_end: this.end_date + ' 00:00:00',
      	priority: this.priority,
      	project_id: this.projectid,
      	assign: this.selectemember,
        check_list: this.check_list
      }).then((response) => {
        if (response.data.status === 'success') {
          // console.log(response.data.data)
          this.isloading = false
          this.$swal('', this.$t('Alert.Success.createTask'), 'success')
          this.$emit('createdtask', {'task_id': response.data.data.task_id,
            'state_id': this.state_id,
            'event': 'create',
            'tokenroom': this.tokenroom,
            'projectid': this.projectid,
            'date_end': this.end_date,
            'date_start': this.start_date
          })
          this.closeDialog()
        }
      }).catch(error => {
        console.log(error.message)
      })
    },
    getroom () {
      this.axios.post(process.env.APImanage + '/getroom', {
        tokenuser: this.token,
        tokenroom: this.tokenroom
      }).then((response) => {
        if (response.data.status === 'success') {
          var member_active = []
          member_active = response.data.data_room
          this.member = _.filter(member_active, function(o) { return o.type !== 'bot' && o.statemember == 'active' })
          this.member.push({
            tokenuser: this.token,
            name: localStorage.getItem('name'),
            profilepicture: localStorage.getItem('profilepicture')
          })
        }
      }).catch(error => {
        console.log(error.message)
      })
    }
  }
}
</script>
<style type="text/css" scoped>
.scrolling-wrapper {
  /*display: flex;*/
  overflow-y: auto;
}
.scrolling-wrapper::-webkit-scrollbar {
  height: 4px;
  width: 8px;
}
.scrolling-wrapper::-webkit-scrollbar-thumb {
  border-radius: 8px;
  background: rgba(0, 0, 0, .1);
}
.font-size15 {
  font-size: 15px !important;
}
.item {
  justify-content: start !important;
  width: 100% !important;
  display: flex !important;
  align-items: start !important;
  /* border-bottom: 1px solid #F1F1F1 !important; */
}
.item:last-child {
  border-bottom: 0;
}
input:checked + p {
  /* background: #F9F9F9; */
  text-decoration: line-through;
}
input[type="checkbox"] {
  margin: 15px;
}
p {
  margin: 0;
  padding-left: 10px;
  transition: background 0.2s;
  flex: 1;
  /* font-family:'helvetica neue'; */
  /* font-size: 20px; */
  font-weight: 200;
  border-left: 1px solid #D1E2FF;
  height: 100%;
  align-items: center !important;
  display: flex !important;
}
.border-checklist {
  border-style: solid !important;
  border-width: thin !important;
  border-radius: 5px !important;
  border-color: #e0e0e0 !important;
  padding: 5px !important;
}
.inputchecklistweb {
  color: black !important;
  font-size: 16px !important;
  height: 40px;
  width: 95% !important;
  border-radius: 5px !important;
  border: 1px #979797 solid !important;
}
>>>.v-card {
  display: block;
  border-radius: 2px;
  min-width: 0;
  position: relative;
  text-decoration: none;
  transition: .3s cubic-bezier(.25,.8,.5,1);
  box-shadow: none !important;
}
>>>.v-stepper {
  box-shadow: none !important;
}
.object-fit-img {
  object-fit: cover;
  object-position: 50% 0;
}
>>>.v-input .v-label {
  height: 25px !important;
  line-height: 24px !important;
}
>>>.v-text-field--outline .v-input__slot {
  min-height: 50px !important;
}
.system-bar {
  height: 3px !important;
  border-radius: 10px !important;
  width: 600px !important;
  margin-left: 55px !important;
  background-color: #d8d8d8 !important;
}
>>>.v-btn-toggle--selected {
  box-shadow: none !important;
}
.text-overflow-chip {
  margin-top: 10px !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  white-space: nowrap !important;
  width: 50px !important;
}
.text-overflow {
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  white-space: nowrap !important;
  width: 250px !important;
}
.selectedPriority {
 border-radius: 5px;
 border: 1px solid #979797;
}
.btn-pri1 {
  /*width: 80px !important;*/
  color: #b3493d !important;
  font-size: 34px !important;
  /*border-radius: 4px !important;*/
}
.btn-pri2 {
  /*width: 80px !important;*/
  color: #fcbe55 !important;
  font-size: 34px !important;
  /*border-radius: 4px !important;*/
}
.btn-pri3 {
  /*width: 80px !important;*/
  color: #a0a1a3 !important;
  /*border-radius: 4px !important;*/
  font-size: 34px !important;
}
>>>.v-input__slot {
  border-radius: 6px !important;
  /* border-color: #949494 !important;
  border-style: solid !important;
  border-width: thin !important; */
  border-width: thin !important;
  box-shadow: none !important;
}
.height-600px {
  height: 600px !important;
}
.toolbar-card {
  background-color: #1e2227 !important;
}
.toolbar-card-v2 {
  background-color: white !important;
}
.btncreate {
  font-weight: 700;
  font-size: 13px !important;
  border-radius: 30px !important;
  margin-left: 0vw !important;
  margin-right: 15px!important;
  /* background: #2562af !important; */
  background-image: linear-gradient(to right, rgb(66, 104, 251), rgb(113, 186, 200)) !important;
  color: white !important;
  width: 120px !important;
  text-transform: none;
}
.btncancle {
  font-size: 13px !important;
  border-radius: 30px !important;
  margin-left: 0vw !important;
  margin-right: 10px !important;
  background: #ffffff !important;
  color: #4268fb !important;
  width: 120px !important;
  border-style: solid !important;
  border-color: #4268fb !important;
  box-shadow: none !important;
  text-transform: none;
}
.text2 {
  white-space: nowrap;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
}

.close-classic:after {
  content: '×';
  font-size: 20px;
  /* ANSI X letter */
}

.containers {
  width: 454px;
  margin: 0 auto;
}

.containers:after {
  content: '';
  display: block;
  clear: both;
}
.listfile {
  overflow-x: scroll !important;
  overflow-y: hidden !important;
  height: 135px !important;
  display: -webkit-inline-box !important;
  background: #f3f2f2 !important;
  padding-top: 17px !important;
  border-radius: 10px !important;
  margin-bottom: 15px !important;
  margin-top: 20px;
}

.borderfile {
  border: 1px solid #00000036;
  border-radius: 5px;
  width: 140px !important;
  height: 100px !important;
  position: relative;
  background: white;
}

.Kanit {
  font-family: 'Kanit', sans-serif !important;
}

.alligator-turtle {

  object-fit: cover;
  object-position: 50% 0;
}

.application .theme--light.input-group input,
.application .theme--light.input-group textarea,
.theme--light .input-group input,
.theme--light .input-group textarea {
  /* color: rgba(0,0,0,.87); */
  color: #53ceff !important;
}

.CSChatThai {
  font-family: 'CS ChatThaiUI' !important;
  word-wrap: break-word;
}

.user-photonote {
  height: 40px !important;
  width: 40px !important;
  background: #ccc;
  border-radius: 50%;
  overflow: hidden;

}

.textchat {
  white-space: nowrap;
  max-width: 9em;
  overflow: hidden;
  text-overflow: ellipsis;
  font-family: 'CS ChatThaiUI' !important;
  text-transform: none;
  display: inline-flex;
}

input[type=text] {
  width: 100%;
  box-sizing: border-box;
  border: 1px solid #b7b7b7;
  border-radius: 30px;
  font-size: 16px;
  background-color: white;
  background-image: url('/static/img/default_profile/group-white.png');
  background-position: 10px 10px;
  background-repeat: no-repeat;
  padding: 12px 20px 12px 20px;
  -webkit-transition: width 0.4s ease-in-out;
  transition: width 0.4s ease-in-out;
}
input[type=text]:focus {
    outline: none !important;
}
>>>.v-input .v-label {
    height: 20px;
    line-height: 24px;
}
>>>.trix-content {
    height: 220px !important;
}
>>>trix-editor:empty:not(:focus)::before {
    content: attr(placeholder);
    color: #858585;
    font-size: 16px;
    cursor: text;
}
>>>.trix-button-group--file-tools {
  display: none;
}
.attachment_file {
  border-radius: 3px;
  border: #bbbbbb 1px solid;
  background: #eee;
  width: fit-content;
  padding-left: 5px;
  padding-right: 5px;
  display: inline-block;
}
>>>.inputtaskweb {
  color: black !important;
  font-size: 16px !important;
  height: 40px;
  width: 75% !important;
  border-radius: 5px !important;
  border: 1px #979797 solid !important;
}
.inputtaskweb-search {
  color: black !important;
  font-size: 16px !important;
  height: 40px;
  width: 100% !important;
  border-radius: 5px !important;
  border: 1px #979797 solid !important;
}
.textSubject {
  margin-top:20px;
  text-align: right;
  padding-right: 20px;
  font-size: 16px;
}
input[type=text]:focus {
    outline: none !important;
}
textarea[type=text]:focus {
    outline: none !important;
}
.InputEdit {
    height: 43px;
    width: 100%;
    padding: 5px 15px !important;
    background-color: #fff;
    border: 1px solid #d2d8dd;
    border-radius: 4px;
    margin-bottom: 15px !important;
}
.v-text-field.v-text-field--solo:not(.v-text-field--solo-flat) .v-input__slot {
    border: 1px #979797 solid;
}
</style>



// WEBPACK FOOTER //
// src/components/chat/manage_task/created_task_calendar_dialog.vue